import styles from "./styles.module.scss"
import NextLink from "next/link"
import cn from "clsx"
import type { FC, HTMLAttributes } from "react"
import type { LinkProps as NextLinkProps } from "next/link"


interface HyperProps {
  theme?: "white" | "gold",
  type?: "ghost" | "bordered" | "filled",
  grow?: boolean,
  seamless?: boolean,
  className?: string,
}

interface LinkProps 
extends HyperProps, NextLinkProps, HTMLAttributes<HTMLAnchorElement> {
  title?: string,
  target?: string,
  rel?: string,
}
interface ButtonProps 
extends HyperProps, HTMLAttributes<HTMLButtonElement> {}

export const Link: FC<LinkProps> = ({ 
  type = 'ghost',
  theme = 'gold',
  grow, seamless, className, children,
  href,
  ...rest
}) => (
  <NextLink href={href}>
    <a {...rest} className={cn(
      styles.element,
      className,
      styles[theme],
      styles[type], 
      { 
        [styles.grow]: grow, 
        [styles.seamless]: seamless,
      }
    )}>
      {children}
    </a>
  </NextLink>
) 

export const Button: FC<ButtonProps> = ({ 
  type = 'ghost',
  theme = 'gold',
  grow, seamless, className,
  ...rest
}) => (
  <button {...rest} className={cn(
    styles.element, 
    className, 
    styles[theme],
    styles[type], 
    { 
      [styles.grow]: grow, 
      [styles.seamless]: seamless,
    }
  )} />
)
